// The region: the Organisation's data-residency choice, set only by the
// platform operator in the admin app. Each sandbox backend maps it, and a
// backend that cannot honour it refuses dispatch rather than running
// elsewhere. Pure, with no node imports, so the browser bundle imports it
// too. See ADR-0043 §3.

/**
 * The regions the write path accepts: the ones the sandbox backends can
 * honour. The schema's CHECK rules out only the empty string, so this list
 * is the rule.
 */
export const REGIONS = ["us", "eu"] as const;
/** One of the accepted regions, a short lowercase token. */
export type Region = (typeof REGIONS)[number];

/** The region an Organisation gets when the operator has not chosen one. */
export const DEFAULT_REGION: Region = "us";

/** Whether a string names an accepted region. */
export function isRegion(value: string): value is Region {
  return (REGIONS as readonly string[]).includes(value);
}

/** The Organisations screen's words for each region. */
export const REGION_LABELS: Record<Region, string> = {
  us: "United States",
  eu: "Europe",
};
